/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

const SearchPager = ({ total, offset, amount, handleUpdateOffset, previousLabel, nextLabel }) => {
    const totalPages = total / amount;
    const pages = [];

    if (totalPages <= 1) {
        return null;
    }

    const handleClick = (i) => {
        handleUpdateOffset(i.selected * amount);
    };

    return (
        <div class="pager has-padding">
            <ReactPaginate
                pageCount={totalPages}
                pageRangeDisplayed={5}
                marginPagesDisplayed={1}
                onPageChange={handleClick}
                containerClassName='pager__items'
                activeClassName='is-active'
                pageClassName='pager__item'
                pageLinkClassName='pager__link underline-link'
                previousClassName='pager__item'
                previousLinkClassName='button is-small'
                previousLabel={previousLabel}
                nextClassName='pager__item'
                nextLinkClassName='button is-small'
                nextLabel={nextLabel}
                forcePage={offset / amount}
            />
        </div>
    );
};

SearchPager.propTypes = {
    total: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
    handleUpdateOffset: PropTypes.func.isRequired,
    nextLabel: PropTypes.string.isRequired,
    previousLabel: PropTypes.string.isRequired,
};

export default SearchPager;
